import { Component, EventEmitter, Input, Output } from '@angular/core';

/** Quiet "Back" text link (the `.bk-more` style) with a leading arrow. */
@Component({
  selector: 'app-back-button',
  standalone: true,
  imports: [],
  templateUrl: './back-button.component.html',
  styleUrl: './back-button.component.css',
})
export class BackButtonComponent {
  @Input() label: string = 'Back';
  @Output() back = new EventEmitter<void>();
}
